import { render } from "./eventCalendarAttributesModal.vue?vue&type=template&id=b9f0aeb6&scoped=true"
import script from "./eventCalendarAttributesModal.vue?vue&type=script&lang=js"
export * from "./eventCalendarAttributesModal.vue?vue&type=script&lang=js"

import "./eventCalendarAttributesModal.vue?vue&type=style&index=0&id=b9f0aeb6&scoped=true&lang=scss"

import exportComponent from "D:\\wemet-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9f0aeb6"]])

export default __exports__